import { getSignalingSocket } from 'services/signaling';
import { ContentLibraryMediaPlayerRemotePayload } from 'features/content-library/types';

export async function requestMediaPlayerState(
  id: string
): Promise<ContentLibraryMediaPlayerRemotePayload | null> {
  try {
    return await getSignalingSocket().sendAsync({
      event: 'requestMediaPlayerState',
      data: { id },
    });
  } catch {
    return null;
  }
}
